import React from 'react';
import { Button } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import { handleButtonClick } from './buttonHandlers';

export default function buttonComponent(props) {
	const {
		analyticsTrackTitle,
		analyticsTitle,
		windowLocationHref,
		buttonName,
		iconVisible,
		buttonShape,
		style, // Add style prop
		onClick, // Add onClick prop to allow custom handlers
		disabled, // Add disabled prop
	} = props;

	// Determine button class based on shape
	const buttonClass = `btn-primary ${
		buttonShape === 'rectangle' ? 'btn-rectangle' : 'btn-round'
	}`;

	// Universal handler for all button clicks
	const handleClick = (e) => {
		// Don't execute if button is disabled
		if (disabled) {
			e.preventDefault();
			return;
		}

		const customHandler = () => {
			// Default analytics tracking
			window.analytics.track(analyticsTrackTitle, {
				title: analyticsTitle,
				action: 'Clicked',
				location: windowLocationHref,
			});
		};

		// Use the universal button handler
		handleButtonClick(e, buttonName, onClick || customHandler);
	};

	return (
		<Button
			className={buttonClass}
			onClick={handleClick}
			style={style}
			disabled={disabled}
		>
			{buttonName !== null ? buttonName : ''}{' '}
			{iconVisible ? <ChevronRight className='btn-icon' size={18} /> : ''}
		</Button>
	);
}
